import { FiSearch } from "react-icons/fi";
import { EmptyState } from "../../../components/ui";

/**
 * Salão inexistente em `/{slug}` e `/{slug}/app` (paridade do LINK-04).
 *
 * Um estado vazio único no lugar do texto cru da API, que antes aparecia três
 * vezes: no "Erro:" da página e em dois toasts (QA de 06/10/2026, L4).
 */
export function PublicNotFound() {
  return (
    <main className="flex min-h-[100dvh] items-center justify-center bg-[#f7f8fc] px-3 py-8 sm:px-6 sm:py-12">
      <EmptyState
        className="w-full max-w-md"
        icon={<FiSearch aria-hidden="true" />}
        title="Página não encontrada"
        description="Confira o endereço com o estabelecimento."
      />
    </main>
  );
}
